import { CheckIcon } from "lucide-react";

const matchInsights = [
  {
    label: "Relevant experience",
    desc: "Your background aligns well with this role level.",
  },
  {
    label: "In-demand skils",
    desc: "You have skills highly valued in target roles.",
  },
  {
    label: "Clear progression",
    desc: "Your career path shows consistent growth.",
  },
  {
    label: "Location alignment",
    desc: "Your preferred location has strong opportunities.",
  },
];

const MatchInsightSection = () => {
  return (
    <div className="flex flex-col bg-white border rounded-xl p-5 gap-2">
      <span className="uppercase font-bold text-xs text-slate-800">
        Match insights
      </span>

      <div className="flex flex-col">
        {matchInsights?.map((insight, insightIndex) => {
          return (
            <div
              key={insight?.label}
              className={`flex gap-4 py-3 ${insightIndex !== 0 ? "border-t" : ""}`}
            >
              <CheckIcon size={17} />
              <div className="flex flex-col gap-1">
                <span className="text-xs font-bold text-slate-800">
                  {insight?.label}
                </span>
                <span className="text-xss font-medium text-light-black">
                  {insight?.desc}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <span className="font-bold text-xs text-slate-800">
        View full match insights
      </span>
    </div>
  );
};

export default MatchInsightSection;
